<template>
    <div class="vx-row mt-8">
        <div class="vx-col w-full">
            <div v-for="(fg, index) in formulation_list" :key="index" class="flex items-center mb-2 gap-4">
                <span @click.stop="onClickViewFg(fg.id)" class="cursor-pointer text-primary">
                    {{ fg.formulation_code }} - {{ fg.name }}
                </span>
                <vs-button
                    v-if="hasCustomerLinks(fg.id)"
                    v-can="'view-bespoke-pricing'"
                    size="small"
                    type="border"
                    @click.stop="onClickViewLinks(fg)">
                    Customer Links
                </vs-button>
            </div>
        </div>
        <formulation-customer-links-pop-up ref="customerLinksPopUp" />
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FormulationCustomerLinksPopUp from '@/components/popups/formulations/FormulationCustomerLinksPopUp.vue'

const FormulationsRepository = RepositoryFactory.get('formulations')

export default {
    name: 'ProductionFormulationListTab',
    components: {
        FormulationCustomerLinksPopUp,
    },
    props: {
        formulation_list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            linkCounts: {},
        }
    },
    watch: {
        formulation_list: {
            immediate: true,
            handler(list) {
                list.forEach(fg => this.fetchLinkCount(fg.id))
            }
        }
    },
    methods: {
        async fetchLinkCount(id) {
            try {
                const { data } = await FormulationsRepository.getBespokeAndContracts(id)
                const count = (data.pagination && data.pagination.total) || (data.data || []).length
                this.$set(this.linkCounts, id, count)
            } catch (e) {
                this.$set(this.linkCounts, id, 0)
            }
        },
        hasCustomerLinks(id) {
            return (this.linkCounts[id] || 0) > 0
        },
        onClickViewFg(id) {
            const route = this.$router.resolve({ path: `/pages/formulations/${id}` });
            window.open(route.href, '_blank');
        },
        onClickViewLinks(fg) {
            this.$refs.customerLinksPopUp.openPopup(fg)
        },
    },
}
</script>
<style lang="">

</style>
